import React, { useCallback, useEffect, useState } from 'react';
import { BsImageFill } from 'react-icons/bs';
import { Chip } from '@material-ui/core';
import { useSelector } from 'react-redux';
import moment from 'moment';

import Default from '../../contenedores/Default';

import CabeceroReportes from '../../componentes/CabeceroReportes';
import ListaConfiguracion from '../../componentes/ListaConfiguracion';
import ListaImagenes from '../../componentes/ListaImagenes';
import Modal from '../../componentes/Modal';
import Tabla from '../../componentes/Table';

import { useFetchReporte } from '../../hooks/useFetchReporte';

import endpoints, {
  CAPTURA_PLANTAS,
  ENFERMEDADES,
  TABLAS,
} from '../../configuraciones/endpoints';
import axios from '../../configuraciones/axios';

import { DatePickerTypes } from '../../constantes/datePickerTypes';
import { mapaDependenciasCompacto } from '../../constantes/reportes';

import styles from './styles';

const datosLista = {
  labelProp: 'nombre',
  headerLista: 'Nombre',
  title: 'Reporte de Plagas & Enfermedades',
  data: [
    {
      id: 1,
      nombre: 'P&E en plantas',
      subTitle: 'Plagas/Enfermedades Encontradas',
    },
    {
      id: 2,
      nombre: 'P&E en trampas',
      subTitle: 'Listado por plaga/enfermedad',
    },
  ],
};

const ReporteEnfermedades = ({ history }) => {
  const classes = styles();

  const { registros } = useSelector((store) => store.listados);
  const { data, formData, buscar, onChange, onDelete } = useFetchReporte(
    {
      tablas: endpoints.base.busqueda(TABLAS),
      surcos: ([_sitios, _invernaderos, _naves, tablas]) =>
        tablas.map(({ surcos = [] }) => surcos).flat(),
      enfermedades: endpoints.base.busqueda(ENFERMEDADES),
    },
    endpoints.reporteEnfermedadesPlantas(),
    { incluirInvernaderos: false },
  );

  const [imagenes, setImagenes] = useState([]);
  const [open, setOpen] = useState(false);
  const [params, setParams] = useState({});

  const handleTodosSelected = useCallback(() => {
    const {
      sitios,
      naves,
      tablas,
      surcos,
      enfermedades,
      incluirValoresCero,
      fecha,
    } = formData;

    const params = {
      sitios,
      naves,
      surcos,
      tablas,
      enfermedades,
      incluirValoresCero,
      fecha: moment(fecha).format('W-GGGG'),
    };
    return params;
  }, [formData]);

  const handleClickOpen = (params) => {
    setParams(params);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onSubMenuClick = (id) => {
    if (id === 1) {
      history.push(`/reportes/enfermedades`);
    } else {
      history.push(`/reportes/trampas`);
    }
  };

  const cabeceros = [
    { label: 'SITIO', key: 'sitio', align: 'left' },
    { label: 'INVERNADERO', key: 'invernadero', align: 'left' },
    { label: 'NAVE', key: 'nave', align: 'left' },
    { label: 'TABLA', key: 'tabla', align: 'left' },
    { label: 'SURCO', key: 'surco', align: 'left' },
    { label: 'CUADRANTE', key: 'cuadrante', align: 'left' },
    { label: 'PLAGA/ENFERMEDAD', key: 'enfermedad', align: 'left' },
    { label: 'CANTIDAD', key: 'valor', align: 'right' },
    {
      label: 'FECHA DE CAPTURA',
      key: 'fecha',
      align: 'center',
      format: (fecha) => moment(fecha).format('LL'),
    },
    {
      label: 'EVIDENCIA',
      key: '',
      align: 'center',
      transform: (data) => {
        if (!data) return null;

        return (
          <Chip
            icon={<BsImageFill color="#FFFF" />}
            className={classes.imagenView}
            label={`Ver`}
            size="small"
            onClick={() => {
              handleClickOpen({
                naveID: data.naveID,
                surcoID: data.surcoID,
                cuadrante: data.cuadrante,
                fecha: data.fecha,
              });
            }}
          />
        );
      },
    },
  ];

  useEffect(() => {
    let itemImagenes = [];
    if (Object.keys(params).length > 0) {
      axios
        .get(endpoints.base.url(`${CAPTURA_PLANTAS}/imagenes`), {
          params,
        })
        .then((plantasImagenesBD) => {
          itemImagenes = plantasImagenesBD.map((element, index) => ({
            ...element,
            title: moment(element.fechaRegistro).format('LLLL'),
            author: '@Del Campo - Scouter',
            featured: true,
          }));
          setImagenes(itemImagenes);
        });
    }
  }, [params]);

  return (
    <Default
      mostrarLista={
        <ListaConfiguracion
          datosLista={datosLista}
          onClick={onSubMenuClick}
          initOpcion={0}
        />
      }
    >
      <CabeceroReportes
        data={data}
        formData={formData}
        buscar={buscar}
        onChange={onChange}
        onDelete={onDelete}
        handleTodosSelected={handleTodosSelected}
        selects={{
          sitio: { width: 3, show: true },
          invernaderoNave: { width: 3, show: true },
          tabla: { width: 3, show: true },
          surco: { width: 3, show: true },
          enfermedad: { width: 3, show: true },
          fecha: { width: 3, show: true, type: DatePickerTypes.week },
          valoresCero: { width: 3, show: true },
        }}
        endpoint={endpoints.reporteEnfermedadesPlantas()}
        method="POST"
        mapaDependencias={mapaDependenciasCompacto}
      />
      <Tabla
        headers={cabeceros}
        rows={registros.rows.length > 0 ? registros.rows : []}
        count={registros.count}
        showActions={false}
      />
      <Modal open={open} handleClose={handleClose} titulo="Imágenes de plantas">
        <ListaImagenes data={imagenes} />
      </Modal>
    </Default>
  );
};

export default ReporteEnfermedades;
